export const exportRfqTemplate = {
  fields: [],
  type: 'RFQ',
  fileTypes: [
    {
      label: 'CSV',
      value: 'csv',
    },
    {
      label: 'XLSX',
      value: 'xlsx',
    },
    {
      label: 'PDF',
      value: 'pdf',
    },
  ],
};
